import { render, staticRenderFns } from "./TransactionsList.vue?vue&type=template&id=52da4bb0&scoped=true&"
import script from "./TransactionsList.vue?vue&type=script&lang=js&"
export * from "./TransactionsList.vue?vue&type=script&lang=js&"
import style0 from "./TransactionsList.vue?vue&type=style&index=0&id=52da4bb0&lang=scss&scoped=true&"
import style1 from "./TransactionsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52da4bb0",
  null
  
)

export default component.exports